import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { changeTheme } from "../../appRedux/actions/common";

const NAV_BAR_LIST = [
  { _id: "01", name: "Home", url: "/", path: "/home", active: true },
  { _id: "02", name: "About", url: "/about", path: "/about", active: false },
  {
    _id: "03",
    name: "Product",
    url: "/products",
    path: "/products",
    active: false,
  },
  {
    _id: "04",
    name: "Contact",
    url: "/contact",
    path: "/contact",
    active: false,
  },
];

export default function Header() {
  // const toggleSwitch = document.querySelector(
  //   '.theme-switch input[type="checkbox"]'
  // );
  const dispatch = useDispatch();
  const [toggleSwitch, setToggleSwitch] = useState(false);
  const currentTheme = localStorage.getItem("theme");
  useEffect(() => {
    if (currentTheme) {
      document.documentElement.setAttribute("data-theme", currentTheme);

      if (currentTheme === "dark") {
        setToggleSwitch(true);
        // toggleSwitch.checked = true;
      }
    }
  }, []);
  console.log("window.location.pathname", window.location.pathname);
  const activeRoute = (routeName) => {
    if (window.location.pathname === "/" && routeName === "/home") {
      return true;
    } else {
      return window.location.pathname.indexOf(routeName) > -1 ? true : false;
    }
  };
  const switchTheme = () => {
    if (!toggleSwitch) {
      document.documentElement.setAttribute("data-theme", "dark");
      localStorage.setItem("theme", "dark");
      dispatch(changeTheme("dark"));
    } else {
      document.documentElement.setAttribute("data-theme", "light");
      localStorage.setItem("theme", "light");
      dispatch(changeTheme("light"));
    }
    setToggleSwitch(!toggleSwitch);
  };

  // toggleSwitch.addEventListener("change", switchTheme, false);
  return (
    <header id="site-header" className="fixed-top">
      <div className="container">
        <nav className="navbar navbar-expand-lg navbar-dark stroke">
          <Link className="navbar-brand pt-1" to="">
            <i className="fa fa-logo-icon"></i>
          </Link>

          {/* <a className="navbar-brand"  >
        <img src="image-path" alt="Your logo" title="Your logo" style="height:35px;" />
    </a>   */}
          {/* <button
            className="navbar-toggler  collapsed bg-gradient"
            type="button"
            data-toggle="collapse"
            data-target="#navbarTogglerDemo02"
            aria-controls="navbarTogglerDemo02"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon fa icon-expand fa-bars"></span>
            <span className="navbar-toggler-icon fa icon-close fa-times"></span>
          </button> */}
          {/* <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
            <ul className="navbar-nav ml-lg-auto">
              {NAV_BAR_LIST.map((row) => {
                return (
                  <li
                    key={Math.random()}
                    className={`nav-item ${activeRoute(row.path) ? "active" : ""}`}
                  >
                    <Link to={row.url} className="nav-link">
                      {row.name}{" "}
                      {activeRoute(row.path) && <span className="sr-only">(current)</span>}
                    </Link>
                  </li>
                );
              })}

              
              <li className="header-search mr-lg-2 mt-lg-0 mt-4 position-relative">
                <div className="search-right">
                  <a
                    href="#search"
                    className="btn btn-style search-btn"
                    title="search"
                  >
                    <span className="fas fa-search mr-2" aria-hidden="true"></span>{" "}
                    Search
                  </a>
                </div>
              </li>
            </ul>
          </div> */}

          {/* 
          <div className="mobile-position">
            <nav className="navigation">
              <div className="theme-switch-wrapper">
                <label className="theme-switch" htmlFor="checkbox">
                  <input type="checkbox" id="checkbox" />
                  <div className="mode-container py-1" onClick={() => switchTheme(toggleSwitch)}>
                    <i className="gg-sun"></i>
                    <i className="gg-moon"></i>
                  </div>
                </label>
              </div>
            </nav>
          </div> */}
        </nav>
      </div>
    </header>
  );
}
